import { DOUBLE_HYPHEN_BULLET, OTHER_RMA_REASONS } from '@/shared/config';
import classNames from 'classnames';
import _ from 'lodash';
import type { ReasonRMAProps } from './reasonRma.types';
import './reasonRma.scss';

const ReasonRMA = ({
  data,
  className,
  classNameItem,
  classNameItemOther,
  classNameItemTitle,
}: ReasonRMAProps): any => {
  const { reasons, lostDeviceNeedReplacement } = data;

  if (_.isEmpty(reasons)) {
    return <div className={classNames(className || 'reason-for-rma')}>{DOUBLE_HYPHEN_BULLET}</div>;
  }

  /**
   * Renders one RMA reason as its label, followed by its free-text description when it has one. Appends the replacement outcome to a lost device reason and applies the component's class-name overrides.
   *
   * @param reason - Reason entry carrying value, label and describe.
   * @returns The reason element.
   */
  const renderReason = (reason: any) => {
    if (reason.describe) {
      return (
        <div key={reason.value} className={classNames(classNameItem || 'item')}>
          <span className={classNames(classNameItemTitle || 'item-title')}>
            {`${reason.label}: `}
          </span>
          <span className={classNames(classNameItemOther || 'item-other')}>{reason.describe}</span>
        </div>
      );
    }
    let { label } = reason;
    if (reason.value === OTHER_RMA_REASONS.LOST_DEVICE) {
      label += lostDeviceNeedReplacement ? ' - Replacement needed' : ' - No replacement';
    }
    return (
      <div key={reason.value} className={classNames(classNameItem || 'item')}>
        {label}
      </div>
    );
  };

  return (
    <div className={classNames(className || 'reason-for-rma')}>
      {_.map(
        _.sortBy(reasons, (reason) => Boolean(reason.describe)),
        renderReason,
      )}
    </div>
  );
};

export default ReasonRMA;
